/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

import Auth from '../../../../data/auth-service';
import TargetService from '../../../../data/target-service';
import SystemService from '../../../../data/system-service';
import DataContext from '../../../../data/data-context';
import Validator, {
    useValidate,
    checkValidity,
} from '../../../../components/validator';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
    },
    button: {
        marginRight: theme.spacing(1),
    },
}));

const CreateTarget = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [targetService, setTargetService] = useState(null);
    const { systemSettings } = useContext(DataContext);
    const [networkInterfaces, setNetworkInterfaces] = useState([
        {
            Description: '',
            NetworkInterfaceId: '',
        },
    ]);
    const [networkLoadBalancer, setNetworkLoadBalancer] = useState([
        {
            Description: '',
            NetworkLoadBalancerArn: '',
        },
    ]);
    const [gatewayLoadBalancerEndpoint, setGatewayLoadBalancerEndpoint] =
        useState([
            {
                Description: '',
                GatewayLoadBalancerEndpointId: '',
            },
        ]);
    const targetForm = useValidate({});
    const [type, setType] = useState('network-interface');
    const [target, setTarget] = useState('');
    const [valid, setValid] = useState(false);
    const [targetdata, setTargetData] = useState({
        TrafficMirrorTargetId: '',
        NetworkInterfaceId: '',
        NetworkLoadBalancerArn: '',
        Type: 'network-interface',
        Description: '',
        OwnerId: '',
        Tags: [
            {
                Key: '',
                Value: '',
            },
        ],
        GatewayLoadBalancerEndpointId: '',
    });
    const awsPerms = Auth.permissions.get('AWS');
    const [readonly] = useState(!awsPerms.write);

    useEffect(() => {
        if (systemSettings && systemSettings.aws) {
            if (!readonly) {
                SystemService.awsCredAccess().then((res) => {
                    if (res) {
                        const region = systemSettings.aws.as_conf.region;
                        const accessKeyId = systemSettings.aws.user_creds.access_key_id;
                        const secretAccessKey = res.AWSSK;
                        initializeService(region, accessKeyId, secretAccessKey);
                    }
                });
            }
        }
    }, [systemSettings]);

    const initializeService = async (awsregion, accessKeyId, secretAccessKey) => {
        const config = {
            region: awsregion,
            credentials: {
                accessKeyId,
                secretAccessKey,
            },
        };
        const service = new TargetService(config);
        setTargetService(service);
    };

    useEffect(() => {
        setValid(
            (targetdata.Description || '').length > 0 &&
            (targetdata[target] || '').length > 0,
            checkValidity(targetForm.get())
        );
    }, [targetdata, targetForm]);

    const handleTargetClose = () => {
        navigate('/system/port_mirroring/aws', { state: { tab: 2 } });
    };

    const handleTargetDescription = (e, validID, valid) => {
        targetForm.set({ ...targetForm.get(), [validID]: valid });
        const t = { ...targetdata };
        t[e.target.name] =
            e.target.type === 'number' ? parseInt(e.target.value) : e.target.value;
        setTargetData(t);
    };

    const handleTargetChange = (event, newValue, field) => {
        targetForm.set({ ...targetForm.get(), [newValue]: field });
        setTargetData((prevData) => ({
            ...prevData,
            [field]: newValue ? newValue[field] : '',
        }));
    };

    const handleTargetType = (e, component) => {
        const TargetType = component.props.value;
        const t = { ...targetdata };
        t.Type = TargetType;
        setTargetData(t);
        setType(TargetType);
    };

    const fetchNetworkInterfaces = async () => {
        try {
            let newTarget;
            // let newTargetValue;
            const res = await targetService.getNetworkInterfaces(type);

            if (res) {
                if (type === 'network-interface') {
                    newTarget = 'NetworkInterfaceId';
                    // newTargetValue = 'targetdata.' + newTarget;
                    const interfacesOptions = res.map((interfaces) => ({
                        Description: interfaces.Description,
                        NetworkInterfaceId: interfaces.NetworkInterfaceId,
                    }));
                    setTarget(newTarget);
                    setNetworkInterfaces(interfacesOptions);
                }
            } else {
                throw new Error(res);
            }
        } catch (error) {
            toast.error(`Failed to fetch  interfaces: ${error}`);
        }
    };

    useEffect(() => {
        if (type && targetService) {
            fetchNetworkInterfaces();
        }
    }, [type, targetService]);

    const handleSubmit = async () => {
        try {
            const res = await targetService.createTarget(targetdata);
            if (res && res.$metadata.httpStatusCode === 200) {
                handleTargetClose();
                SystemService.addAuditRecord({ "source": "AWS config", "subject": targetdata.Description, "action": "create mirror target", "result": true });
                toast.success('Target created successfully');
            } else {
                throw new Error(res);
            }
        } catch (error) {
            SystemService.addAuditRecord({ "source": "AWS config", "subject": "AWS Mirror Target", "action": "Error: " + error, "result": false });
            toast.error(`Failed to create Target: ${error}`);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper >
                    <Box p={5}>
                        <Grid container>
                            <Grid item xs={12} container>
                                <Box>
                                    <Typography variant="h6">Create Traffic Mirror Target</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} container spacing={2} marginTop={2}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth margin="normal">
                                        <Validator
                                            disabled={readonly}
                                            errorText="Target description cannot be empty"
                                            fullWidth
                                            label="Target Description"
                                            name="Description"
                                            value={targetdata.Description}
                                            onChange={(e, validID, valid) => {
                                                handleTargetDescription(e, validID, valid);
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth margin="normal">
                                        <InputLabel id="target-type">Target Type</InputLabel>
                                        <Select
                                            disabled={readonly}
                                            value={targetdata.Type}
                                            onChange={handleTargetType}
                                            label="Target Type"
                                            name="Type"
                                            required
                                        >
                                            <MenuItem value="network-interface">
                                                Network Interface
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth margin="normal">
                                        <Autocomplete
                                            disabled={readonly}
                                            value={
                                                targetdata[target] ? targetdata[target].toString() : ''
                                            }
                                            onChange={(event, newValue) =>
                                                handleTargetChange(
                                                    event,
                                                    newValue || null,
                                                    target
                                                )
                                            }
                                            options={
                                                type === 'network-interface'
                                                    ? networkInterfaces
                                                    : type === 'network_load_balancer'
                                                        ? networkLoadBalancer
                                                        : type === 'gateway_load_balancer_endpoint'
                                                            ? gatewayLoadBalancerEndpoint
                                                            : []
                                            }
                                            getOptionLabel={(option) => {
                                                if (typeof option === 'object') {
                                                    if (type === 'network-interface') {
                                                        return `${option.NetworkInterfaceId} - ${option.Description}`;
                                                    } else if (type === 'network_load_balancer') {
                                                        return `${option.NetworkLoadBalancerArn} - ${option.Description}`;
                                                    } else if (type === 'gateway_load_balancer_endpoint') {
                                                        return `${option.GatewayLoadBalancerEndpointId} - ${option.Description}`;
                                                    }
                                                }
                                                return option;
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Target Destination" />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} mt={2} container justifyContent="flex-end">
                                <Box mr={2}>
                                    <Button
                                        onClick={handleTargetClose}
                                        variant="contained"
                                        color="secondary"
                                        className={classes.button}
                                    >
                                        {readonly ? 'Back' : 'Cancel'}
                                    </Button>
                                    {!readonly && <Button
                                        onClick={handleSubmit}
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        disabled={!valid}
                                    >
                                        Save
                                    </Button>}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default CreateTarget;
